<template>
	<div class="Catalog-xxl-foot" v-if="loginstate">
		<div class="Catalog-xxl-foot-div">
			<img src="../img/portrait.png" alt class="Catalog-xxl-foot-div-img" />
			<div class="Catalog-xxk-mydiv">
				<router-link to="/login">
					<p class="Catalog-xxk-mydiv-p">登录</p>
				</router-link>
				<p class="Catalog-xxk-mydiv-p1">后可参与讨论</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},

		data() {
			//这里存放数据
			return {
				loginstate: true
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			cklogin() {
				if (this.$cookies.isKey("token")) {
					this.loginstate = false;
				}
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.cklogin();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style>
	.Catalog-xxl-foot {
		height: 160px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Catalog-xxl-foot-div-img {
		width: 44px;
		height: 44px;
		margin: 0 auto;
	}

	.Catalog-xxk-mydiv {
		display: flex;
		margin-top: 16px;
	}

	.Catalog-xxk-mydiv-p {
		font-size: 14px;
		color: #28a3b1;
	}

	.Catalog-xxk-mydiv-p1 {
		font-size: 14px;
	}

	.Catalog-mydiv2 {
		background-color: #f5f5f5;
	}
</style>



// WEBPACK FOOTER //
// src/components/publiclogin.vue